export default __webpack_public_path__ + "static/HarmoniaSansProCyr-Bold-f51120985905cca5e90fadc4dd759b1a.woff";